import {
  FETCH_ALL_FLASHCARD_TYPES,
  CREATE_FLASHCARD_TYPE,
  UPDATE_FLASHCARD_TYPE,
  DELETE_FLASHCARD_TYPE,
} from '../constants/actionTypes';
import * as api from '../api/index.js';

export const getFlashcardTypes = () => async (dispatch) => {
  try {
    const { data } = await api.fetchFlashcardTypes();
    dispatch({ type: FETCH_ALL_FLASHCARD_TYPES, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const createFlashcardType = (flashcardType) => async (dispatch) => {
  try {
    const { data } = await api.createFlashcardType(flashcardType);
    dispatch({ type: CREATE_FLASHCARD_TYPE, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const updateFlashcardType =
  (id, flashcardType) => async (dispatch) => {
    try {
      const { data } = await api.updateFlashcardType(id, flashcardType);
      dispatch({ type: UPDATE_FLASHCARD_TYPE, payload: data });
    } catch (error) {
      console.log(error.message);
    }
  };

export const deleteFlashcardType = (id) => async (dispatch) => {
  try {
    await api.deleteFlashcardType(id);
    dispatch({ type: DELETE_FLASHCARD_TYPE, payload: id });
  } catch (error) {
    console.log(error.message);
  }
};
